import { Global } from '@emotion/react';
import type { GetDocumentResponse, SectionByDocumentIdApiResponse } from 'services/documents/DocumentRepository';
import PreviewSections from 'components/preview/PreviewSections';
import type { DocumentStyle } from 'pages/preview/documentStyleForPreviewProps';

type PreviewCanvasProps = {
  sections: SectionByDocumentIdApiResponse[];
  documentData: GetDocumentResponse;
  documentStyle: DocumentStyle;
};

const PreviewCanvas = ({ sections, documentData, documentStyle }: PreviewCanvasProps) => {
  return (
    <>
      <Global styles={documentStyle?.textStyle || {}} />
      <Global styles={documentStyle?.tableRowStyles || {}} />
      <PreviewSections
        documentStyle={documentStyle?.canvas || {}}
        contentId={documentData.contentId}
        sections={sections}
        isDocumentLocked={documentData.isLocked}
        totalType={documentData?.totalType}
      />
    </>
  );
};

export default PreviewCanvas;
